import React from 'react';
import useStyles from '../admin-styles';
import AccountLogout from './AccountLogout';
import CreateMenu from './CreateMenu';
import NavigationList from './List';

const Navigation = () => {
  const classes = useStyles();
  return (
    <div className={classes.nav_root}>
      <div style={{display: 'flex'}}>
        <div className={classes.nav_title_container}>
          <h1 className={classes.nav_title}>Fullcap Dominó</h1>
          <small className={classes.nav_title_caption}>
            Fundación Full Dominó Colombia
          </small>
        </div>
        <NavigationList />
      </div>
      <div style={{display: 'flex'}}>
        <CreateMenu />
        <AccountLogout />
      </div>
    </div>
  );
};

export default Navigation;
